module.exports = __webpack_public_path__ + "static/video-c8c407af3493ea4ef9959fa5460c15b0.mp4";